var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkmodeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20351 9.1853C7.38101 5.64965 8.36516 2.4785 9.26729 0.738017C9.44043 0.409968 9.15794 0.036355 8.78433 0.0819175C4.20986 0.701568 0.710657 4.70195 0.902019 9.48602C0.911132 9.48602 0.911132 9.48602 0.911132 9.49513C1.47611 9.24909 2.08664 9.1124 2.73363 9.1124C4.24631 9.1124 5.63141 9.86874 6.46976 11.0716C7.99154 11.509 9.11238 12.9123 9.11238 14.5799C9.11238 15.965 8.31959 17.1587 7.18053 17.7784C8.07356 18.07 9.03037 18.234 10.0145 18.234C12.8667 18.234 15.4091 16.9218 17.0858 14.8715C17.3227 14.5799 17.1223 14.1516 16.7487 14.1243C14.4796 14.0058 11.026 12.7301 9.20351 9.1853Z",
    fill: "#4A5866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4675 11.7576H5.30347C4.92075 10.7005 3.91838 9.93506 2.73375 9.93506C1.22108 9.93506 0 11.1561 0 12.6688C0 14.1815 1.22108 15.4026 2.73375 15.4026C3.29873 15.4026 5.00276 15.4026 5.4675 15.4026C6.46988 15.4026 7.29 14.5824 7.29 13.5801C7.29 12.5777 6.46988 11.7576 5.4675 11.7576Z",
    fill: "#4A5866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmodeOff);
export default __webpack_public_path__ + "static/media/darkmode-off.d672c5b489d6b2b911a9a20cbb6f2fba.svg";
export { ForwardRef as ReactComponent };